import { RootState } from "app/store";
import AppCopy from "copy/AppCopy";
import { formatStatNumber } from "functions/text";
import React from "react";
import { useSelector } from "react-redux";

function AllTimeStatCard() {
  const { totalStat } = useSelector((state: RootState) => state.stat);
  const {
    assignedText,
    callsText,
    cancelledText,
    messageText,
    postText,
    rentPostText,
    rentText,
    sellPostText,
    soldText,
    statusText,
    usersText,
    allTimeText,
  } = AppCopy.stat;
  return (
    <div className={Classname.container}>
      <div className={Classname.titleRow}>
        <div className={Classname.title}>{statusText}</div>
        <div className={Classname.type}>{allTimeText}</div>
      </div>
      {/* Assigned */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagAssigned}`}></div>
          <div className={Classname.rowText}>{assignedText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalAssigned)}
        </div>
      </div>
      {/* Sold */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagSold}`}></div>
          <div className={Classname.rowText}>{soldText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalSold)}
        </div>
      </div>
      {/* Rented */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagRented}`}></div>
          <div className={Classname.rowText}>{rentText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalRented)}
        </div>
      </div>
      {/* Cancelled */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCancelled}`}></div>
          <div className={Classname.rowText}>{cancelledText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalCancelled)}
        </div>
      </div>
      {/* Post */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCommon}`}></div>
          <div className={Classname.rowText}>{postText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalPost)}
        </div>
      </div>
      {/* Sell Post */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCommon}`}></div>
          <div className={Classname.rowText}>{sellPostText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalSalePost)}
        </div>
      </div>
      {/* Rent Post */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCommon}`}></div>
          <div className={Classname.rowText}>{rentPostText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalRentPost)}
        </div>
      </div>
      {/* Message */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCommon}`}></div>
          <div className={Classname.rowText}>{messageText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalMessages)}
        </div>
      </div>
      {/* Calls */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCommon}`}></div>
          <div className={Classname.rowText}>{callsText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalCalls)}
        </div>
      </div>
      {/* Users */}
      <div className={Classname.row}>
        <div className={Classname.rowLeft}>
          <div className={`${Classname.tag} ${Classname.tagCommon}`}></div>
          <div className={Classname.rowText}>{usersText}</div>
        </div>
        <div className={Classname.rowNum}>
          {formatStatNumber(totalStat?.totalUsers)}
        </div>
      </div>
    </div>
  );
}

export default AllTimeStatCard;

const Classname = {
  container:
    "bg-white p-4 flex-1 lg:w-72 box-border rounded-md text-primaryText",
  titleRow: "w-full items-center flex flex-row justify-between mt-2 mb-6",
  title: "text-secondaryText text-base",
  type: "text-primaryText text-xs bg-bgPrimary px-2 py-1 rounded-sm",
  row: "w-full flex items-center justify-between my-2",
  rowLeft: "gap-2 flex items-center text-base ",
  rowNum: "",
  tag: "w-4 h-4 rounded-full",
  tagAssigned: "bg-statusAssigned",
  tagSold: "bg-statusSold",
  tagRented: "bg-statusRented",
  tagCancelled: "bg-statusCancelled",
  tagCommon: "bg-neutral",
  rowText: "",
  rowAmount: "",
};
